import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {map} from 'rxjs/operators';
import {ISubdimensao} from '../models/subdimensao.model';

const subdimensoes: ISubdimensao[] = [
  {id: 0, idDimensao: 0, dimensao: 'equipe', nome: 'conhecimento', caption: 'Conhecimento'},
  {id: 1, idDimensao: 0, dimensao: 'equipe', nome: 'habilidade', caption: 'Habilidade'},
  {id: 2, idDimensao: 0, dimensao: 'equipe', nome: 'atitude', caption: 'Atitude'},
  {id: 3, idDimensao: 1, dimensao: 'produto', nome: 'mix_geral', caption: 'Mix de Produto >> Geral'},
  {id: 4, idDimensao: 1, dimensao: 'produto', nome: 'mix_marcas', caption: 'Mix de Produto >> Marcas'},
  {id: 5, idDimensao: 1, dimensao: 'produto', nome: 'mix_faixa_preco', caption: 'Mix de Produto >> Faixa de Preço'},
  {id: 6, idDimensao: 1, dimensao: 'produto', nome: 'mix_quantidade', caption: 'Mix de Produto >> Quantidade'},
  {id: 7, idDimensao: 1, dimensao: 'produto', nome: 'mix_variedade', caption: 'Mix de Produto >> Variedade'},
  {id: 8, idDimensao: 1, dimensao: 'produto', nome: 'qualidade', caption: 'Qualidade'},
  {id: 9, idDimensao: 4, dimensao: 'loja', nome: 'localizacao_geral', caption: 'Localização >> Geral'},
  {id: 10, idDimensao: 4, dimensao: 'loja', nome: 'localizacao_macro', caption: 'Localização >> Macro'},
  {id: 11, idDimensao: 4, dimensao: 'loja', nome: 'localizacao_micro', caption: 'Localização >> Micro'},
  {id: 12, idDimensao: 4, dimensao: 'loja', nome: 'fachada_geral', caption: 'Fachada >> Geral'},
  {id: 13, idDimensao: 4, dimensao: 'loja', nome: 'fachada_placa', caption: 'Fachada >> Placa'},
  {id: 14, idDimensao: 4, dimensao: 'loja', nome: 'fachada_iluminacao', caption: 'Fachada >> Iluminação'},
  {id: 15, idDimensao: 4, dimensao: 'loja', nome: 'fachada_formato', caption: 'Fachada >> Formato'},
  {id: 16, idDimensao: 4, dimensao: 'loja', nome: 'fachada_pintura', caption: 'Fachada >> Pintura'},
  {id: 17, idDimensao: 4, dimensao: 'loja', nome: 'fachada_conservacao', caption: 'Fachada >> Conservação'},
  {id: 18, idDimensao: 4, dimensao: 'loja', nome: 'vitrine_geral', caption: 'Vitrine >> Geral'},
  {id: 19, idDimensao: 4, dimensao: 'loja', nome: 'vitrine_organizacao', caption: 'Vitrine >> Organização'},
  {id: 20, idDimensao: 4, dimensao: 'loja', nome: 'vitrine_expositores', caption: 'Vitrine >> Expositores'},
  {id: 21, idDimensao: 4, dimensao: 'loja', nome: 'vitrine_moveis', caption: 'Vitrine >> Móveis'},
  {id: 22, idDimensao: 4, dimensao: 'loja', nome: 'vitrine_iluminacao', caption: 'Vitrine >> Iluminação'},
  {id: 23, idDimensao: 4, dimensao: 'loja', nome: 'entrada', caption: 'Entrada'},
  {id: 24, idDimensao: 4, dimensao: 'loja', nome: 'piso_tipo', caption: 'Piso >> Tipo'},
  {id: 25, idDimensao: 4, dimensao: 'loja', nome: 'piso_conservacao', caption: 'Piso >> Conservação'},
  {id: 26, idDimensao: 4, dimensao: 'loja', nome: 'parede_geral', caption: 'Parede >> Geral'},
  {id: 27, idDimensao: 4, dimensao: 'loja', nome: 'parede_tipo', caption: 'Parede >> tipo'},
  {id: 28, idDimensao: 4, dimensao: 'loja', nome: 'parede_conservacao', caption: 'Parede >> Conservação'},
  {id: 29, idDimensao: 4, dimensao: 'loja', nome: 'moveis_geral', caption: 'Moveis >> Geral'},
  {id: 30, idDimensao: 4, dimensao: 'loja', nome: 'moveis_balcao', caption: 'Moveis >> Balcão'},
  {id: 31, idDimensao: 4, dimensao: 'loja', nome: 'moveis_mesa', caption: 'Moveis >> Mesa'},
  {id: 32, idDimensao: 4, dimensao: 'loja', nome: 'moveis_cadeira', caption: 'Moveis >> Cadeira'},
  {id: 33, idDimensao: 2, dimensao: 'processo', nome: '', caption: 'Processo (Método)'},
  {id: 34, idDimensao: 3, dimensao: 'preco', nome: '', caption: 'Preço (Medida)'},
  {id: 35, idDimensao: 5, dimensao: 'meio_ambiente', nome: '', caption: 'Meio Ambiente'}
];

@Injectable()
export class SubdimensoesService {

  getSubdimensoes(): Observable<ISubdimensao[]> {
    return Observable.from(subdimensoes)
      .pipe(map(data => {
        return <ISubdimensao>data;
      }))
      .toArray();
  }

  getSubdimensaoByDimensao(dimensao: string) {
    return subdimensoes.reduce((result, subdimensao) => {
      if (subdimensao.dimensao === dimensao) {
        result.push(subdimensao.caption);
      }
      return result;
    }, []);
  }
}

